var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cagura-wrapper"},[_c('div',{staticClass:"content-widget"},[_c('h1',{staticClass:"main-text"},[_vm._v("Page you are trying to find not found !!!")])])])
}]

export { render, staticRenderFns }